import Vue from 'vue';
import VueRecaptcha from 'vue-recaptcha';

// @vue/component
export default Vue.extend({
    props: {
        firstChannelId: {
            type: Number,
            default: 1
        },
    },
    components: { VueRecaptcha },
    data() {
        return {
            user: {
                channelId: this.firstChannelId,
                state: 'AL',
                recaptcha: '',
            },
            form: {},
            busy: false,
            alert: {}
        };
    },

    mounted() {
        this.form = new Form2(this.user)
            .setAction('/start-trial');
    },

    methods: {
        onVerify(response) {
            console.log(response)
            this.user.recaptcha = response;
        },
        submit() {
            if (this.busy) {
                return;
            }

            this.busy = true;
            this.alert = {};

            this.form.post()
                .then(data => {
                    console.log(data)
                    if (data.results && data.results.saved) {
                        window.location.href = '#try-now';
                        this.alert = {
                            alert: 'success',
                            type: 'success',
                            message: data.message
                        };
                        this.$refs.recaptcha.reset();
                    }else if (data.error){
                        this.alert = {
                            alert: 'danger',
                            message:data.errors['recaptcha'].join()
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                })
                .finally(() => this.busy = false);
        }
    }
});